import { makeStyles } from '@material-ui/styles';

export default makeStyles({
  root: {
    height: `100vh`,
    width: '100vw',
    background: 'black'
  }
});
